window.pillovelyDeliveryVariantCache = window.pillovelyDeliveryVariantCache || {};
var pillovelyDeliveryVariantCache = window.pillovelyDeliveryVariantCache;
window.pillovelyDeliveryProductCache = window.pillovelyDeliveryProductCache || {};
var pillovelyDeliveryProductCache = window.pillovelyDeliveryProductCache;

function pillovelyIsPolishMarket() {
  const shopify = window.Shopify || {};
  const locale = String(shopify.locale || "").toLowerCase();
  const market =
    typeof shopify.market === "string"
      ? shopify.market
      : shopify.market && (shopify.market.handle || shopify.market.countryCode || shopify.market.country);

  return locale === "pl" || String(market || "").toLowerCase() === "pl";
}

function pillovelyFormatMoney(price) {
  const numericPrice = Number(price);
  if (Number.isNaN(numericPrice)) return "";

  const amount = typeof price === "string" && price.includes(".")
    ? numericPrice
    : numericPrice / 100;

  return `${amount.toLocaleString("pl-PL", { maximumFractionDigits: 2 })} zł`;
}

async function pillovelyGetDeliveryProduct(handle) {
  if (!handle) return null;
  if (pillovelyDeliveryProductCache[handle]) return pillovelyDeliveryProductCache[handle];

  const response = await fetch(`/products/${handle}.json`, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Nie znaleziono produktu uslugi: ${handle}`);
  }

  const payload = await response.json();
  const product = payload && payload.product;
  const variant = product && product.variants && product.variants[0];

  if (!product || !variant || !variant.id) {
    throw new Error(`Produkt uslugi nie ma wariantu: ${handle}`);
  }

  pillovelyDeliveryProductCache[handle] = product;
  pillovelyDeliveryVariantCache[handle] = variant.id;
  return product;
}

async function pillovelyGetDeliveryVariantId(handle) {
  if (!handle) return null;
  if (pillovelyDeliveryVariantCache[handle]) return pillovelyDeliveryVariantCache[handle];

  const product = await pillovelyGetDeliveryProduct(handle);
  return product && product.variants && product.variants[0] && product.variants[0].id;
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.renderDeliveryServiceWidget();
      this.interceptDynamicCheckout();
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (!this.isDeliveryServiceSelected()) {
        this.showDeliveryRequiredDialog();
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const deliveryService = await this.resolveDeliveryService(formData);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            await this.addSelectedDeliveryService(response, formData, deliveryService);
            window.location = window.routes.cart_url;
            return;
          }

          const deliveryResponse = await this.addSelectedDeliveryService(response, formData, deliveryService);
          const cartResponse = deliveryResponse || response;

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(cartResponse) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(cartResponse);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async renderDeliveryServiceWidget() {
      const widget = this.querySelector(".pillovely-delivery-widget");
      if (!widget || !pillovelyIsPolishMarket()) return;

      const serviceHandles = this.getDeliveryServiceHandles(widget);
      if (!serviceHandles || !serviceHandles.length) return;

      if (widget.dataset.deliveryWarning) {
        console.warn(`[Pillovely delivery service] ${widget.dataset.deliveryWarning}`);
      }

      const fieldset = document.createElement("fieldset");
      fieldset.className = "pillovely-delivery-widget__options";

      const legend = document.createElement("legend");
      legend.className = "pillovely-delivery-widget__title subtitle";
      legend.textContent = "Usługa dostawy";
      fieldset.appendChild(legend);

      this.appendDeliveryServiceOption(fieldset, {
        label: "Przesyłka kurierska bez wniesienia",
        price: "bezpłatnie",
        handle: "",
      }, 0);

      widget.replaceChildren(fieldset);

      const serviceProducts = await Promise.all(
        serviceHandles.map(async (handle) => {
          try {
            return await pillovelyGetDeliveryProduct(handle);
          } catch (error) {
            console.warn(`[Pillovely delivery service] Nie mozna pobrac uslugi ${handle}.`, error);
            return null;
          }
        })
      );

      serviceProducts.filter(Boolean).forEach((product, index) => {
        const variant = product.variants && product.variants[0];
        this.appendDeliveryServiceOption(fieldset, {
          label: product.title,
          price: variant && variant.price ? pillovelyFormatMoney(variant.price) : "",
          handle: product.handle,
        }, index + 1);
      });
    }

    getDeliveryServiceHandles(widget) {
      return (widget.dataset.deliveryServiceHandles || "")
        .split(",")
        .map((handle) => handle.trim())
        .filter(Boolean);
    }

    appendDeliveryServiceOption(fieldset, option, index) {
      const id = `DeliveryService-${this.form.id}-${index}`;
      const label = document.createElement("label");
      label.className = "pillovely-delivery-widget__option small-font";
      label.setAttribute("for", id);

      const input = document.createElement("input");
      input.type = "radio";
      input.name = "pillovely_delivery_service";
      input.id = id;
      input.value = option.handle;
      input.dataset.serviceHandle = option.handle;
      input.checked = false;

      const text = document.createElement("span");
      text.className = "pillovely-delivery-widget__option-text";

      const labelText = document.createElement("span");
      labelText.textContent = option.label;
      text.appendChild(labelText);

      if (option.price) {
        const price = document.createElement("span");
        price.className = "pillovely-delivery-widget__price";
        price.textContent = option.price;
        text.appendChild(price);
      }

      label.append(input, text);
      fieldset.appendChild(label);
    }

    getSelectedDeliveryServiceHandle() {
      const selected = this.querySelector('.pillovely-delivery-widget input[name="pillovely_delivery_service"]:checked');
      return selected ? selected.dataset.serviceHandle : "";
    }

    hasDeliveryServiceWidget() {
      return Boolean(this.querySelector(".pillovely-delivery-widget"));
    }

    isDeliveryServiceSelected() {
      if (!this.hasDeliveryServiceWidget() || !pillovelyIsPolishMarket()) return true;
      return Boolean(this.querySelector('.pillovely-delivery-widget input[name="pillovely_delivery_service"]:checked'));
    }

    showDeliveryRequiredDialog() {
      let dialog = this.querySelector(".pillovely-delivery-dialog");
      if (!dialog) {
        dialog = document.createElement("dialog");
        dialog.className = "pillovely-delivery-dialog";
        const p = document.createElement("p");
        p.textContent = "Wybierz usługę dostawy przed dodaniem do koszyka.";
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "button button--primary pillovely-delivery-dialog__close";
        btn.textContent = "OK";
        btn.addEventListener("click", () => dialog.close());
        dialog.append(p, btn);
        this.appendChild(dialog);
      }
      dialog.showModal();
    }

    interceptDynamicCheckout() {
      const checkoutContainer = this.querySelector(".product-form__checkout");
      if (!checkoutContainer || !this.hasDeliveryServiceWidget()) return;

      checkoutContainer.style.position = "relative";

      const overlay = document.createElement("div");
      overlay.style.cssText = "position:absolute;inset:0;z-index:1;cursor:pointer;";
      checkoutContainer.appendChild(overlay);

      overlay.addEventListener("click", async (evt) => {
        evt.stopPropagation();
        evt.preventDefault();

        if (!this.isDeliveryServiceSelected()) {
          this.showDeliveryRequiredDialog();
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        try {
          const formData = new FormData(this.form);
          const deliveryService = await this.resolveDeliveryService(formData);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const response = await fetch(routes.cart_add_url, config);
          const result = await response.json();

          if (result.status) {
            this.handleErrorMessage(result.description);
            return;
          }

          await this.addSelectedDeliveryService(result, formData, deliveryService);
          window.location = '/checkout';
        } catch (error) {
          console.error('[Pillovely delivery service] Buy now error:', error);
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
        }
      });
    }

    async resolveDeliveryService(formData) {
      const deliveryService = {
        handle: this.getSelectedDeliveryServiceHandle(),
        useParentQuantity: false,
      };

      if (!this.hasDeliveryServiceWidget() || !deliveryService.handle) return deliveryService;

      const cart = await this.fetchCartState();
      const existingDeliveryService = this.getExistingDeliveryService(cart, formData.get("id"));

      if (existingDeliveryService && !existingDeliveryService.childItem) {
        deliveryService.useParentQuantity = true;
      }

      return deliveryService;
    }

    async fetchCartState() {
      try {
        const response = await fetch(`${routes.cart_url}.js`, {
          headers: { Accept: "application/json" },
        });

        if (!response.ok) throw new Error("Nie udalo sie pobrac koszyka.");
        return await response.json();
      } catch (error) {
        console.warn("[Pillovely delivery service] Nie mozna sprawdzic aktualnego koszyka.", error);
        return null;
      }
    }

    getExistingDeliveryService(cart, variantId) {
      if (!cart || !cart.items || !variantId) return null;

      const parentItem = cart.items.find((item) => {
        const isDeliveryServiceLine = item.properties && item.properties._parent_key;
        return !isDeliveryServiceLine && String(item.variant_id) === String(variantId);
      });

      if (!parentItem) return null;

      const childItem = cart.items.find((item) => {
        return item.properties && item.properties._parent_key === parentItem.key;
      });

      return {
        parentItem,
        childItem,
      };
    }

    async addSelectedDeliveryService(parentResponse, formData, deliveryService) {
      const serviceHandle = deliveryService && deliveryService.handle;
      if (!serviceHandle || !parentResponse || !parentResponse.key) return null;

      try {
        const variantId = await pillovelyGetDeliveryVariantId(serviceHandle);
        if (!variantId) return null;

        const quantity = deliveryService.useParentQuantity
          ? Math.max(parseInt(parentResponse.quantity, 10) || 1, 1)
          : Math.max(parseInt(formData.get("quantity"), 10) || 1, 1);
        const payload = {
          id: variantId,
          quantity,
          properties: {
            _parent_key: parentResponse.key,
          },
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify(payload);

        const response = await fetch(`${routes.cart_add_url}`, config);
        const parsedResponse = await response.json();

        if (!response.ok || parsedResponse.status) {
          console.warn(`[Pillovely delivery service] Nie udalo sie dodac uslugi ${serviceHandle}.`, parsedResponse);
          return null;
        }

        return parsedResponse;
      } catch (error) {
        console.warn(`[Pillovely delivery service] Pominieto usluge ${serviceHandle}.`, error);
        return null;
      }
    }
  });
}
